import React, { memo } from "react";
import formatAnswer from "../../utils/form/formatAnswer";
import { useTranslation } from "react-i18next";
import RenderMatrixSummary from "../questionnaire/RenderMatrixSummary";

/**
 * ReviewStep
 * ----------
 * Final read-only summary shown before form submission.
 *
 * Props
 *  • questions: array – filtered questions in display order
 *  • formData: object – answers keyed by question.id
 *  • title?: string – optional heading text
 *  • translationForm?: string | string[] – i18next namespace(s) for form copy
 */
/* ------------------------------------------------------------------ */
/* Main component                                                      */
/* ------------------------------------------------------------------ */
function ReviewStep({
  questions,
  formData,
  title = "Review Your Information",
  translationForm = "form",
}) {
  const { t } = useTranslation();
  const { t: tForm } = useTranslation(translationForm);

  if (!Array.isArray(questions) || !questions.length) return null;

  return (
    <div className="review-step space-y-4 w-full">
      <h2 className="text-xl font-bold">{t("reviewStep.title")}</h2>

      <div className="space-y-2">
        {questions.map((q) => {
          const label = q.titleKey ? tForm(q.titleKey) : q.title;
          const isMatrix = q.fieldType === "boolean-matrix";

          return (
            <div
              key={q.id}
              className={
                isMatrix
                  ? "border-b border-greyscale-1 pb-2 space-y-2"
                  : `flex ${
                      translationForm === "sgrq" ? "flex-col" : ""
                    } justify-between border-b border-greyscale-1 pb-2`
              }
            >
              <span className="font-semibold">{label}</span>

              {isMatrix ? (
                <RenderMatrixSummary
                  question={q}
                  t={tForm}
                  formData={formData}
                />
              ) : (
                <span className="whitespace-pre-line">
                  {formatAnswer(q, formData, tForm)}
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default memo(ReviewStep);
